import React from 'react'; // React könyvtár importálása, hogy React komponenseket használhassunk
import ReactDOM from 'react-dom/client'; // React DOM modul importálása, amely a React komponensek rendereléséért felelős
import App from './App'; // Az alkalmazás fő komponensének importálása
import { BrowserRouter } from 'react-router-dom'; // A `BrowserRouter` komponens importálása, amely a React Router-t használja az útvonalak kezelésére

const rootElement = document.getElementById('root'); // A HTML fájlban található 'root' ID-jú elem lekérése, amely az alkalmazás renderelési helye

if (rootElement) { // Ha a root elem megtalálható...
  const root = ReactDOM.createRoot(rootElement); // Létrehozzuk a gyökér React elemet a root elem alapján

  root.render( // Az alkalmazás renderelése
    <BrowserRouter> {/* A `BrowserRouter` komponens biztosítja a navigációt az alkalmazás különböző útvonalai között */}
      <App /> {/* Az App komponens a fő alkalmazás, amely tartalmazza az összes oldalt és navigációt */}
    </BrowserRouter>
  );
}
